export default "__VITE_ASSET__Db_Mrn6d__"